import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import UIKIT from 'uikit';

import {percelRegistAction, loadPercelRegistsAction} from '../../../reducers/order';

import PercelRegistFormModal from './PercelRegistFormModal';
import PercelRegistTableStyle from './PercelRegistTableStyle';
import {getAgoDate} from '../../../common';

const PercelRegistModal = ({openPercelRegistModal, setOpenPercelRegistModal}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const {loadPercelRegistsDone, loadPercelRegistsError, percelRegists, percelRegistDone, percelRegistLoading} =
    useSelector(state => state.order);

  useEffect(() => {
    if (openPercelRegistModal) {
      let search = {
        dateSelect: 'all',
        searchType: 'all',
        status: 'all',
        regdate: getAgoDate(7),
      };
      search = JSON.stringify(search);
      const query = `per_page=5&search=${btoa(search)}`;
      dispatch(loadPercelRegistsAction(query));
    }
  }, [openPercelRegistModal]);

  useEffect(() => {
    if (!percelRegistLoading && percelRegistDone && openPercelRegistModal) {
      // 로딩이 끝나면 데이터를 다시 가져옴
      let search = {
        dateSelect: 'all',
        searchType: 'all',
        status: 'all',
        regdate: getAgoDate(7),
      };
      search = JSON.stringify(search);
      const query = `per_page=5&search=${btoa(search)}`;
      dispatch(loadPercelRegistsAction(query));
    }
  }, [percelRegistLoading, percelRegistDone, openPercelRegistModal, dispatch]);

  return (
    <div
      id="percelRegistModal"
      className="uk-modal-container uk-overflow-auto uk-position-z-index-9999999"
      data-uk-modal="container: false;"
    >
      <div
        className="uk-modal-body uk-modal-dialog uk-margin-auto-vertical uk-padding-small"
        data-uk-overflow-auto
        style={{width: '850px'}}
      >
        <div className="uk-height-300">
          <button
            className="uk-modal-close-default"
            type="button"
            data-uk-close
            style={{top: '15px', right: '15px'}}
          ></button>
          <div className="uk-width-1-1">
            <h4 className="uk-margin-small-bottom">송장 일괄 등록</h4>
          </div>
          <hr className="uk-margin-small-top uk-border-gray" />
          <PercelRegistFormModal />
        </div>
        {percelRegistLoading ? (
          <div className="uk-text-center" style={{height: '250px'}}>
            <div className="uk-margin-auto-vertical" data-uk-spinner></div>
          </div>
        ) : (
          <div>
            <PercelRegistTableStyle />
          </div>
        )}
      </div>
    </div>
  );
};

export default PercelRegistModal;
